<template>
	<div class="foregroundAudio">
		<h5>Foreground Audio</h5>
		
		<div v-if="hasForegroundAudio">
			<div class="form-group" v-if="hasBespokeAudio">
				<AudioUploader @file-added="updateFileNames"></AudioUploader>
				<div v-for="(property, size, index) in componentItemContent['foreground-audio'].bespoke" :key="size">
					<label>{{ size }}</label>
					<input v-if="size == 'source'" disabled type="text" class="form-control" :id="size" v-model="componentItemContent['foreground-audio'].bespoke['source']" >
					<input v-if="size == 'cta'" type="text" class="form-control" :id="index" v-model="componentItemContent['foreground-audio'].bespoke['cta']" >
					<input v-if="size == 'title'" type="text" class="form-control" :id="index" v-model="componentItemContent['foreground-audio'].bespoke['title']" >
					<input v-if="size == 'autoplay'" type="checkbox" :id="index" v-model="componentItemContent['foreground-audio'].bespoke['autoplay']" >
					<input v-if="size == 'background-colour'" type="text" class="form-control" :id="index" v-model="componentItemContent['foreground-audio'].bespoke['background-colour']" >
				</div>
			
				<button type="submit" class="btn m-2 icons-round" @click.stop.prevent="removeBespokeAudio">
					<img src="~@/assets/icons/minus.svg">
				</button>


			</div>

			<div class="form-group" v-if="hasAcastAudio">
				<div v-for="(property, key, index) in componentItemContent['foreground-audio'].acast" :key="key">
					<label>{{ key }}</label>
					<input v-if="key == 'iframe_embed'" type="text" class="form-control" :id="index" v-model="componentItemContent['foreground-audio'].acast['iframe_embed']" >
					<div v-if="key == 'transcript'" id="app" class="ql-editor-container">
						<vue-editor  v-model="componentItemContent['foreground-audio'].acast['transcript']" :editorToolbar="customToolbar"></vue-editor>
					</div>
				</div>
				<button type="submit" class="btn m-2 icons-round" @click.stop.prevent="removeAcasteAudio">
					<img src="~@/assets/icons/minus.svg">
				</button>

			</div>

			<div v-if="!hasBespokeAudio && this.componentItemSampleContent.bespoke">
				<h6>Bespoke</h6>
				<button type="submit" class="btn m-2 icons-round" @click.stop.prevent="addBespokeAudio">
					<img src="~@/assets/icons/add.svg">
				</button>
			</div>

			<div v-if="!hasAcastAudio && this.componentItemSampleContent.acast">
				<h6>Acast</h6>
				<button type="submit" class="btn m-2 icons-round" @click.stop.prevent="addAcastAudio">
					<img src="~@/assets/icons/add.svg">
				</button>
			</div>

			<button type="submit" class="btn m-2 icons-round" @click.stop.prevent="removeForegroundAudio">
				<img src="~@/assets/icons/minus.svg">
			</button>

		</div>
		<div v-if="!hasForegroundAudio">
			<button type="submit" class="btn m-2 icons-round" @click.stop.prevent="addForegroundAudio">
				<img src="~@/assets/icons/add.svg">
			</button>
		</div>

	</div>
</template>

<script>
	import AudioUploader from './AudioUploader';
	import { VueEditor } from "vue2-editor";
	export default {
		components: {
			AudioUploader,
			VueEditor
		},		
		name: 'ForegroundAudio',
		
		props: ['componentItemContent', 'componentItemSampleContent'],

		data() {
			return {
				hasForegroundAudio: false,
				hasBespokeAudio: false,
				hasAcastAudio: false,
				customToolbar: [["bold", "italic", ],["link"]]
			}
		},
		
		mounted() {
			if(this.componentItemContent['foreground-audio']) {
				this.hasForegroundAudio = true;
				if(this.componentItemContent['foreground-audio'].bespoke){
					this.hasBespokeAudio = true;
				}
				if(this.componentItemContent['foreground-audio'].acast){
					this.hasAcastAudio = true;
				}
			}
		},

		methods: {
			updateFileNames:function(fileName){
				this.componentItemContent['foreground-audio'].bespoke.source = fileName
			},
			addForegroundAudio() {
				this.componentItemContent['foreground-audio'] = {}
				this.hasForegroundAudio = true;
			},
			addBespokeAudio() {
				this.componentItemContent['foreground-audio'].bespoke = this.componentItemSampleContent.bespoke
				this.hasBespokeAudio = true;
			},
			addAcastAudio() {
				this.componentItemContent['foreground-audio'].acast = this.componentItemSampleContent.acast
				this.hasAcastAudio = true;
			},
			removeForegroundAudio() {
				delete this.componentItemContent['foreground-audio'];
				this.hasForegroundAudio = false;
			},
			removeBespokeAudio() {
				delete this.componentItemContent['foreground-audio'].bespoke
				this.hasBespokeAudio = false;
			},
			removeAcasteAudio() {
				delete this.componentItemContent['foreground-audio'].acast
				this.hasAcastAudio = false;
			}
		}

	}
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	.ForegroundAudio{
		padding:20px 0;
	}

	label {
		display: block;
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}
	
</style>